import { Utilities, type Showcases } from 'core/domains';

export const initialState: Showcases = {
  data: [],
  availableShowcases: [],
  isRunning: false,
  updatedAt: 0,
  status: Utilities.STATUS.IDLE,
  message: '',
};
